export const defaultOptions = {
  draggable: false,
  connectable: false,
  position: {
    x: 0,
    y: 0,
  },
};
